import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-autofit-up', 'IconArrowAutofitUp', [
  ['path', { d: 'M12 4h-6a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h8', key: 'svg-0' }],
  ['path', { d: 'M18 20v-17', key: 'svg-1' }],
  ['path', { d: 'M15 6l3 -3l3 3', key: 'svg-2' }],
]);
